import { AlertColor } from "@mui/material";
import type {
  Kitchen,
  Product,
  Table,
  TableOrder,
  TableOrderProduct,
} from "../pages/api";

export interface IMessage {
  type: AlertColor;
  message: string;
}

export interface Message {
  type: AlertColor;
  message: string;
}

export interface INotification {
  id: string;
  title: string;
  description: string;
  avatar: string | null;
  type: SocketUpdateType;
  link: string;
  createdAt: string;
  isUnRead: boolean;
  data?: SocketNotificationData;
}

export interface IOption {
  value: any;
  label: string;
}

export interface ITemplate {
  t: any;
  appUser: any;
  logo: string;
  data: any;
  type?: string;
  qrLink?: string;
  qrLabel?: string;
  isUsePrintServer?: boolean;
}

export interface ITransport {
  mode: number;
  id: string;
  name: string;
  documentNumber: string;
  documentDate: string;
  vehicleType: string;
  vehicleNumber: string;
  distance: string;
  supplyType: string;
  subSupplyType: string;
}

export interface IUpdateEWB {
  transporterId: string;
  transporterName: string;
  transportMode: number;
  transporterDocumentNumber: string;
  transporterDocumentDate: string;
  vehicleType: string;
  vehicleNumber: string;
  remainingDistance: string;
  reasonCode: string;
  reason: string;
  remark: string;
}

export interface PrintRequestBody {
  id: string;
  primaryIp: string;
  primary: any;
  backupIp?: string;
  backup?: any;
  text?: any;
  image?: any;
  iskot?: boolean;
  isBill?: boolean;
  isTableTransfer?: boolean;
  kot?: any;
  bill?: any;
}

export interface KOTItem {
  name: string;
  unit: string;
  quantity: string;
  remarks?: string;
  isCanceled: boolean;
  isUpdated?: boolean;
  oldQuantity?: string;
}

export interface KOT {
  date: string;
  shopName: string;
  billNumber: string;
  tableName?: string;
  isParcel: boolean;
  orderType: string;
  kitchenName: string;
  printer: any;
  items: Array<KOTItem>;
}

export enum PaymentTerm {
  HOUR = "hour",
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}

export enum AccountType {
  CASH = "CASH",
  BANK = "BANK",
  DIGITAL_WALLET = "DIGITAL_WALLET",
  POS = "POS",
}

export enum Role {
  SUPERADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  SUPERVISOR = "SUPERVISOR",
  WORKER = "WORKER",
}

export enum Module {
  STORE = "STORE",
  CATEGORY = "CATEGORY",
  CATEGORY_IMAGE = "CATEGORY_IMAGE",
  PRODUCT = "PRODUCT",
  PRODUCT_IMAGE = "PRODUCT_IMAGE",
  PURCHASE = "PURCHASE",
  SALES = "SALES",
  ORDER = "ORDER",
  INVOICE = "INVOICE",
  QUOTATION = "QUOTATION",
  TABLE_ORDER = "TABLE_ORDER",
  DISTRIBUTION = "DISTRIBUTION",
  TABLE = "TABLE",
  KITCHEN = "KITCHEN",
  KITCHEN_SECTION = "KITCHEN_SECTION",
  KITCHEN_PRODUCT = "KITCHEN_PRODUCT",
  SUPPLIER = "SUPPLIER",
  CUSTOMER = "CUSTOMER",
  TRANSFER = "TRANSFER",
  STOCK_ADD = "STOCK_ADD",
  STOCK_REMOVE = "STOCK_REMOVE",
  STOCK_RECORD = "STOCK_RECORD",
  WASTAGE = "WASTAGE",
  EXPENSES = "EXPENSES",
  EXPENSE_RECEIPT = "EXPENSE_RECEIPT",
  INCOME = "INCOME",
  IECATEGORY = "IECATEGORY",
  IEREMINDER = "IEREMINDER",
  COUNTER_CLOSING = "COUNTER_CLOSING",
  ACCOUNTS = "ACCOUNTS",
  USER = "USER",
  USER_WORKLOG = "USER_WORKLOG",
  USER_SALARY = "USER_SALARY",
  TRANS_PAY = "TRANS_PAY",
  TRANS_RECEIVE = "TRANS_RECEIVE",
  PURCHASE_AMOUNT = "PURCHASE_AMOUNT",
  SALES_AMOUNT = "SALES_AMOUNT",
  ORDER_AMOUNT = "ORDER_AMOUNT",
  ORDER_FILE = "ORDER_FILE",
  PURCHASE_FILE = "PURCHASE_FILE",
  TABLE_ORDER_AMOUNT = "TABLE_ORDER_AMOUNT",
  INVOICE_AMOUNT = "INVOICE_AMOUNT",
  BRANCH = "BRANCH",
  SETTINGS = "SETTINGS",
  PROFILE = "PROFILE",
  PROFILE_PICTURE = "PROFILE_PICTURE",
  SETTINGS_LOGO = "SETTINGS_LOGO",
  PRODUCT_PRICE = "PRODUCT_PRICE",
  CUSTOMER_BALANCE = "CUSTOMER_BALANCE",
  SUPPLIER_BALANCE = "SUPPLIER_BALANCE",
  CUSTOMER_PAY = "CUSTOMER_PAY",
  CUSTOMER_RECEIVE = "CUSTOMER_RECEIVE",
  SUPPLIER_PAY = "SUPPLIER_PAY",
  SUPPLIER_RECEIVE = "SUPPLIER_RECEIVE",
  ATTENDANCE = "ATTENDANCE",
  KITCHEN_PRINTER = "KITCHEN_PRINTER",
  COUNTER_PRINTER = "COUNTER_PRINTER",
  PRINTER_SERVICE_PATH = "PRINTER_SERVICE_PATH",
  PRINTER_USED_FOR = "PRINTER_USED_FOR",
  BACKUP_PRINTER = "BACKUP_PRINTER",
  USAGE = "USAGE",
  VOUCHER = "VOUCHER",
  OUTDOOR_MENU = "OUTDOOR_MENU",
  OUTDOOR_MENU_PRODUCT = "OUTDOOR_MENU_PRODUCT",
  VESSEL = "VESSEL",
  OUTDOOR_ORDER = "OUTDOOR_ORDER",
  OUTDOOR_ORDER_AMOUNT = "OUTDOOR_ORDER_AMOUNT",
  OUTDOOR_QUOTATION = "OUTDOOR_QUOTATION",
  DEPARTMANT = "DEPARTMANT",
  SHIFT = "SHIFT",
  FEEDBACK = "FEEDBACK",
  CUSTOMER_LOYALTY_SETTINGS = "CUSTOMER_LOYALTY_SETTINGS",
  CUSTOMER_OFFER_SETTINGS = "CUSTOMER_OFFER_SETTINGS",
  LOAN = "LOAN",
  DEVICE = "DEVICE",
  DOCUMENT = "DOCUMENT",
  COLLECTION = "COLLECTION",
  KYC = "KYC",
  LINE = "LINE",
  LOANTYPE = "LOANTYPE",
  OFFLINEEVENT = "OFFLINEEVENT",
  ROUTE = "ROUTE",
  SESSION = "SESSION",
  VISIT = "VISIT",
  ACCOUNT = "ACCOUNT",
  COUNTER = "COUNTER",
  CASHIER_SESSION = "CASHIER_SESSION",
  CASH_MOVEMENT = "CASH_MOVEMENT",
  SUBSCRIPTION = "SUBSCRIPTION",
  WALLET = "WALLET",
  STOCK_COUNT = "STOCK_COUNT",
}

export enum Action {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  ADD = "ADD",
  REMOVE = "REMOVE",
  APPROVE = "APPROVE",
  CANCEL = "CANCEL",
  DECLINE = "DECLINE",
  RESEND = "RESEND",
  RETURN = "RETURN",
  COMPLETE = "COMPLETE",
  // GENERATE = "GENERATE",
  EINVOICE = "EINVOICE",
  EWAYBILL = "EWAYBILL",
  CANCEL_EINVOICE = "CANCEL_EINVOICE",
  CANCEL_EWAYBILL = "CANCEL_EWAYBILL",
  UPDATE_VEHICLE = "UPDATE_VEHICLE",
  EXTEND_VALIDITY = "EXTEND_VALIDITY",
  UPDATE_TRANSPORTER = "UPDATE_TRANSPORTER",
  ACCEPT = "ACCEPT",
  COOKED = "COOKED",
  SERVE = "SERVE",
  CONVERT = "CONVERT",
  CLOSE = "CLOSE",
  GENERATE_SCHEDULE = "GENERATE_SCHEDULE",
  UPDATE_VARIANT = "UPDATE_VARIANT",
  BLOCK = "BLOCK",
  UNBLOCK = "UNBLOCK",
  VERIFY = "VERIFY",
  START = "START",
  OPEN = "OPEN",
  CHECKIN = "CHECKIN",
  CHECKOUT = "CHECKOUT",
  SKIP = "SKIP",
}

export const ActionMap = {
  [Action.CREATE]: "created",
  [Action.UPDATE]: "updated",
  [Action.DELETE]: "deleted",
  [Action.ADD]: "added",
  [Action.REMOVE]: "removed",
  [Action.APPROVE]: "approved",
  [Action.CANCEL]: "canceled",
  [Action.DECLINE]: "declined",
  [Action.RESEND]: "resent",
  [Action.RETURN]: "returned",
  [Action.COMPLETE]: "completed",
  // [Action.GENERATE]: "generated",
  [Action.EINVOICE]: "generatede-invoice",
  [Action.EWAYBILL]: "generatede-waybill",
  [Action.CANCEL_EINVOICE]: "cancelede-invoice",
  [Action.CANCEL_EWAYBILL]: "cancelede-waybill",
  [Action.UPDATE_VEHICLE]: "updated-vehiclee-waybill",
  [Action.EXTEND_VALIDITY]: "extended-validitye-waybill",
  [Action.UPDATE_TRANSPORTER]: "updated-transportere-waybill",
  [Action.ACCEPT]: "accepted",
  [Action.COOKED]: "cooked",
  [Action.SERVE]: "served",
  [Action.CONVERT]: "converted",
  [Action.CLOSE]: "closed",
  [Action.GENERATE_SCHEDULE]: "generated-schedule",
  [Action.UPDATE_VARIANT]: "updated-variant",
  [Action.BLOCK]: "blocked",
  [Action.UNBLOCK]: "unblocked",
  [Action.VERIFY]: "verified",
  [Action.START]: "started",
  [Action.OPEN]: "opened",
  [Action.CHECKIN]: "checkedin",
  [Action.CHECKOUT]: "checkedout",
  [Action.SKIP]: "skipped",
};

export enum OrderStage {
  OrderPlaced = "order_placed",
  Processing = "processing",
  ReadyToPick = "ready_to_pick",
  Picking = "picking",
  Verifying = "verifying",
  Packing = "packing",
  Shipping = "shipping",
  Delivered = "delivered",
  OnHold = "on_hold",
  Canceled = "canceled",
}

export enum UserPaymentType {
  PAY = "PAY",
  RECEIVE = "RECEIVE",
  EDIT = "EDIT",
}

export enum DiscountType {
  PERCENTAGE = "percentage",
  FLAT = "flat",
}

export enum UploadType {
  ORDER = "order",
  PURCHASE = "purchase",
  LOGO = "logo",
  PICTURE = "picture",
  CATEGORY_IMAGE = "category-image",
  PRODUCT_IMAGE = "product-image",
  EXPENSE_RECEIPT = "expense-receipt",
}

export const enum TableStatus {
  VACANT = "Vacant",
  PARTIALLY_VACANT = "Partially Vacant",
  DINING = "Dining",
  CLEANING = "Cleaning",
}

export const enum KitchenProductStatus {
  WAITING = "Waiting",
  ACCEPTED = "Accepted",
}

export enum OrderProductStatus {
  CREATED = "Created",
  UPDATED = "Updated",
  RESENT = "Resent",
  WAITING = "Waiting",
  ACCEPTED = "Accepted",
  DECLINED = "Declined",
  COOKED = "Cooked",
  SERVED = "Served",
}

export enum VariantType {
  Text = "text",
  SingleSelect = "single_select",
  MultiSelect = "multi_select",
}

export enum SocketUpdateType {
  CREATE_TABLE = "createTable",
  UPDATE_TABLE = "updateTable",
  DELETE_TABLE = "deleteTable",
  CREATE_ORDER = "createOrder",
  UPDATE_ORDER = "updateOrder",
  DELETE_ORDER = "deleteOrder",
  GENERATE_BILL = "generateBill",
  COMPLETE_ORDER = "completeOrder",
  UPDATE_ORDER_PRODUCT = "updateOrderProduct",
}

type SocketTable = Table & { isActive: boolean };
type SocketTableUpdate = Pick<SocketTable, "id" | "isActive"> &
  Partial<Omit<SocketTable, "id" | "isActive">>;
type SocketTableOrder = TableOrder & {
  closedAt?: string | null;
  removedProductIds?: string[];
};
type SocketOrderProduct = TableOrderProduct & {
  kitchen?: Pick<Kitchen, "id" | "name">;
  order?: Pick<TableOrder, "id" | "billNumber">;
  product?: Product;
};

export type SocketUpdateData = {
  [SocketUpdateType.CREATE_TABLE]: SocketTable;
  [SocketUpdateType.UPDATE_TABLE]: SocketTableUpdate;
  [SocketUpdateType.DELETE_TABLE]: { ids: string | string[]; name?: string };
  [SocketUpdateType.CREATE_ORDER]: SocketTableOrder;
  [SocketUpdateType.UPDATE_ORDER]: SocketTableOrder;
  [SocketUpdateType.DELETE_ORDER]: { ids: string | string[]; name?: string };
  [SocketUpdateType.GENERATE_BILL]: {
    id: string;
    orderId: string;
    tableId?: string;
    billNumber?: string;
    tableName?: string;
    isGenerateBill: boolean;
  };
  [SocketUpdateType.COMPLETE_ORDER]: {
    id: string;
    orderId: string;
    tableId?: string;
    billNumber?: string;
    tableName?: string;
    isCleaning?: boolean;
  };
  [SocketUpdateType.UPDATE_ORDER_PRODUCT]: {
    orderId: string;
    orderProductId: string;
    orderProduct: SocketOrderProduct;
    isResendRequest?: boolean;
  };
};

export type SocketUpdate = {
  [Type in SocketUpdateType]: {
    type: Type;
    data: { data: SocketUpdateData[Type]; by?: string };
  };
}[SocketUpdateType];

export interface SocketNotificationData {
  by: string;
  id?: string;
  name?: string;
  billNumber?: string;
  tableName?: string;
  isCleaning?: boolean;
  isGenerateBill?: boolean;
  productName?: string;
  kitchenName?: string;
  isResendRequest?: boolean;
}

export enum ConvertTo {
  SALE = "Sale",
  ORDER = "Order",
  INVOICE = "Invoice",
}

export enum PaymentType {
  CASH = "CASH",
  CARD = "CARD",
  UPI = "UPI",
  CHEQUE = "CHEQUE",
  BANK = "BANK",
  CREDIT = "CREDIT",
  // Paid into more than one account (eg. part cash, part UPI).
  SPLIT = "SPLIT",
}

export enum CashierSessionStatus {
  OPEN = "OPEN",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  CLOSED = "CLOSED",
}

export enum CashMovementType {
  PAY_IN = "PAY_IN",
  SAFE_DROP = "SAFE_DROP",
  PAID_OUT = "PAID_OUT",
}

// Sales dashboard channels: sales, orders, table orders, outdoor orders.
export enum SalesChannel {
  SALE = "sa",
  ORDER = "or",
  RESTAURANT = "re",
  OUTDOOR_ORDER = "oo",
  INVOICE = "in",
  CUSTOMER = "cu",
  PURCHASE = "pu",
  SUPPLIER = "su",
  EXPENSE = "ex",
  INCOME = "ic",
}

export enum SaleType {
  RETAIL = "RETAIL",
  WHOLESALE = "WHOLESALE",
  COMMISSION = "COMMISSION",
  WHATSAPP = "WHATSAPP",
}

export enum SaleStatus {
  CONFIRMED = "CONFIRMED",
  PROCESSING = "PROCESSING",
  SHIPPED = "SHIPPED",
  CANCELLED = "CANCELLED",
  DELIVERED = "DELIVERED",
}

export enum OfferType {
  FLAT = "FLAT",
  PERCENTAGE = "PERCENTAGE",
  BUY_AND_GET = "BUY_AND_GET",
  COMBO_SAVINGS = "COMBO_SAVINGS",
  COMBO_PRODUCT = "COMBO_PRODUCT",
  GIFT_PRODUCT = "GIFT_PRODUCT",
}

export interface AppItem {
  app: string;
  title: string;
  path: string;
  icon: string;
  color: string;
  description: string;
  isActive: boolean;
}

/** Why stock was thrown away (wastage.reason); the API has the same. */
export enum WastageReason {
  EXPIRED = "EXPIRED",
  SPOILED = "SPOILED",
  DAMAGED = "DAMAGED",
  OVERPRODUCTION = "OVERPRODUCTION",
  PREPARATION = "PREPARATION",
  RETURNED = "RETURNED",
  STAFF_MEAL = "STAFF_MEAL",
  COMPLIMENTARY = "COMPLIMENTARY",
  OTHER = "OTHER",
}

/** A stock count: a draft while counting, then completed or cancelled. */
export enum StockCountStatus {
  DRAFT = "DRAFT",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum Access {
  BRANCH = "branch",
  USER = "user",
  CATEGORY = "category",
  CUSTOMER = "customer",
  EXPENSE = "expense",
  INCOME = "income",
  FEEDBACK = "feedback",
  HISTORY = "history",
  RESTAURANT = "restaurant",
  INVOICE = "invoice",
  ORDER = "order",
  PRODUCT = "product",
  PURCHASE = "purchase",
  QUOTATION = "quotation",
  SALE = "sale",
  STOCK = "stock",
  STORE = "store",
  SUPPLIER = "supplier",
  TRANSFER = "transfer",
  USAGE = "usage",
  VOUCHER = "voucher",
  WASTAGE = "wastage",
  PAYROLL = "payroll",
  ACCOUNTS = "accounts",
  CAPTAIN_APP = "captain-app",
  SALE_APP = "sale-app",
  KITCHEN_DISPLAY = "kitchen-display",
  RESTAURANT_STORE = "restaurant-store",
  OUTDOOR_ORDER = "outdoor-order",
  E_INVOICE = "e-invoice",
  E_WAYBILL = "e-waybill",
  GST_FILING = "gst-filing",
  CRM = "crm",
  FINANCE = "finance",
  ACCOUNT = "account",
  WA_BILL = "wa-bill",
  EMAIL_BILL = "email-bill",
  WA_SALE = "wa-sale",
  STOCK_COUNTS = "stock-counts",
  PRODUCTION_COSTING = "production-costing",
  DELIVERY_APP_PRICING = "delivery-app-pricing",
}

export enum App {
  APP = "app",
  MYAPP = "myapp",
  RESTAURANT = "restaurant",
  BAKERY = "bakery",
  SUPERMARKET = "supermarket",
  MILL = "mill",
  FURNITURE = "furniture",
  PHARMACY = "pharmacy",
  BAR = "bar",
  RESTOBAR = "restobar",
  MOBILESHOP = "mobileshop",
  FINANCE = "finance",
  BRICKS = "bricks",
  POULTRY = "poultry",
  ACCOUNTS = "accounts",
  PAYROLL = "payroll",
  CRM = "crm",
  TEXTILES = "textiles",
  JEWELLERY = "jewellery",
  ELECTRONICS = "electronics",
  HARDWARE = "hardware",
  STATIONERY = "stationery",
  GIFTSHOP = "giftshop",
  ICECREAM = "icecream",
  FOOTWEAR = "footwear",
  FRUITS = "fruits",
  SPORTS = "sports",
  PAINT = "paint",
  PETS = "pets",
  BAGS = "bags",
  COSMETICS = "cosmetics",
  WATCHSHOP = "watchshop",
  OPTICALS = "opticals",
  PERFUME = "perfume",
  SILVERWARE = "silverware",
  TYRESHOP = "tyreshop",
  FERTILIZERS = "fertilizers",
  BICYCLESHOP = "bicycleshop",
  STEELS = "steels",
  PLYWOOD = "plywood",
  LIGHTSHOP = "lightshop",
  SNACKSHOP = "snackshop",
  TILESSTORE = "tilesstore",
  LAPTOPSTORE = "laptopstore",
  REPAIRSERVICES = "repairservices",
}

export enum SupportingApp {
  CAPTAIN_APP = "captain-app",
  SALE_APP = "sale-app",
}

export enum SubscriptionType {
  BASIC = "basic",
  GROWTH = "growth",
  SCALE = "scale",
}

export interface Subscription {
  app: string;
  type: SubscriptionType;
  isFree: boolean;
  duration: number;
  activeTill: Date;
  branches: number;
  users: number;
  hasSales: boolean;
  hasOrder: boolean;
  hasInvoice: boolean;
  hasRestaurant: boolean;
  hasStaff: boolean;
  hasExpense: boolean;
  hasAccounts: boolean;
  hasHistory: boolean;
  amount: boolean;
}

export interface ITaxEngine {
  isApplicable: boolean;
  type: string;
  rate: number;
}

/** What a client payment was for (same as the API's ClientPaymentType). */
export enum ClientPaymentType {
  SUBSCRIPTION = "SUBSCRIPTION",
  ADD_ON = "ADD_ON",
  WALLET_TOP_UP = "WALLET_TOP_UP",
}

/** Why the wallet balance changed (same as the API's WalletTransactionType). */
export enum WalletTransactionType {
  TOP_UP = "TOP_UP",
  SUBSCRIPTION = "SUBSCRIPTION",
  ADD_ON = "ADD_ON",
  E_INVOICE = "E_INVOICE",
  E_INVOICE_WITH_EWB = "E_INVOICE_WITH_EWB",
  E_WAY_BILL = "E_WAY_BILL",
  E_INVOICE_CANCEL = "E_INVOICE_CANCEL",
  E_WAY_BILL_CANCEL = "E_WAY_BILL_CANCEL",
  E_WAY_BILL_VEHICLE_UPDATE = "E_WAY_BILL_VEHICLE_UPDATE",
  E_WAY_BILL_VALIDITY_EXTEND = "E_WAY_BILL_VALIDITY_EXTEND",
  E_WAY_BILL_TRANSPORTER_UPDATE = "E_WAY_BILL_TRANSPORTER_UPDATE",
}

/** Where a client payment stands (same as the API's ClientPaymentStatus). */
export enum ClientPaymentStatus {
  CREATED = "CREATED",
  PAID = "PAID",
  FAILED = "FAILED",
}
